const checkUpDown = (today, yesterday) => {
  return today > yesterday;
};

export default checkUpDown;
